import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { queryClient } from 'app/app';
import { toast } from 'react-toastify';
import { PaginationState } from 'app/shared/pagination/pagination.model';
import {
  CaseZoningPlanComplianceModel,
  CaseZoningPlanModel,
} from 'app/edozvola/cases/case-zoning-plan-compliance/model/case-zoning-plan-compliance.model';
import {
  deleteCaseZoningPlan,
  fetchCaseZoningPlans,
  fetchIspuZoningPlan,
  getZoningPlanCompliance,
  saveCaseZoningPlan,
  saveZoningPlanCompliance,
} from 'app/edozvola/cases/case-zoning-plan-compliance/service/case-zoning-plan-compliance.service';
import { ERRORS } from 'app/config/constants';
import success = toast.success;
import error = toast.error;
import info = toast.info;

export const saveCaseZoningPlanQuery = (idCase: string, onSuccessCallback) => {
  return useMutation({
    mutationFn: (caseZoningPlan: CaseZoningPlanModel) => {
      return saveCaseZoningPlan(idCase, caseZoningPlan);
    },
    onSuccess: () => {
      showToast(success, 'Podaci su uspješno spremljeni.');
      queryClient.invalidateQueries({ queryKey: ['case-zoning-plans-table'] });
      queryClient.invalidateQueries({ queryKey: ['zoning-plan-compliance'] });
      onSuccessCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const fetchCaseZoningPlansQuery = (pagination: PaginationState, idCase: string) => {
  return useQuery({
    queryKey: ['case-zoning-plans-table', { idCase: idCase, pagination: { ...pagination } }],
    queryFn: ({ signal }) => fetchCaseZoningPlans(idCase, pagination.page, pagination.size, pagination.column, pagination.direction),
  });
};

export const deleteCaseZoningPlanQuery = () => {
  return useMutation({
    mutationFn: (idCaseZoningPlan: number) => deleteCaseZoningPlan(idCaseZoningPlan),
    onSuccess: () => {
      showToast(success, 'Podaci su uspješno obrisani.');
      queryClient.invalidateQueries({ queryKey: ['case-zoning-plans-table'] });
      queryClient.invalidateQueries({ queryKey: ['zoning-plan-compliance'] });
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const saveZoningPlanComplianceQuery = (idCase: string, resetFunction) => {
  return useMutation({
    mutationFn: (zoningPlanCompliance: CaseZoningPlanComplianceModel) => saveZoningPlanCompliance(idCase, zoningPlanCompliance),
    onSuccess: (data, variables, context) => {
      showToast(success, 'Podaci su uspješno spremljeni.');
      queryClient.invalidateQueries({queryKey: ['zoning-plan-compliance', { idCase: idCase }]})
      resetFunction({ values: variables });
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const fetchZoningPlanComplianceQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['zoning-plan-compliance', { idCase: idCase }],
    queryFn: ({ signal }) => getZoningPlanCompliance(idCase),
  });
};

export const fetchIspuZoningPlanQuery = (idCase: string) => {
  return useMutation({
    mutationFn: () => fetchIspuZoningPlan(idCase),
    onSuccess: (result: { hasData: boolean; errorMessage?: string }) => {
      if (result.errorMessage) {
        showToast(error, `Nije moguće dohvatiti podatke! ${result.errorMessage}`);
        return;
      }
      if (result.hasData) {
        showToast(success, 'Važeći prostorni planovi dohvaćeni iz ISPU servisa');
        queryClient.invalidateQueries({ queryKey: ['case-zoning-plans-table'] });
        queryClient.invalidateQueries({ queryKey: ['zoning-plan-compliance'] });
      } else {
        showToast(info, 'Servis nije vratio informacije o prostornim planovima');
      }
    },
    onError: () => {
      showToast(error, ERRORS.ZONING_PLAN_SERVICE_NOT_WORKING_ERROR);
    },
  });
};
